"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[495],{

/***/ 81
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class DesktopNavLinkController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ['dropdown', 'toggle']

  open() {
    if (!this.hasDropdownTarget) return

    this.dropdownTarget.classList.remove('hidden')
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute('aria-expanded', 'true')
    }
  }

  close() {
    if (!this.hasDropdownTarget) return

    this.dropdownTarget.classList.add('hidden')
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute('aria-expanded', 'false')
    }
  }

  toggle() {
    if (!this.hasDropdownTarget) return

    const isHidden = this.dropdownTarget.classList.contains('hidden')
    isHidden ? this.open() : this.close()
  }

  closeOnFocusOut(event) {
    if (!this.hasDropdownTarget) return

    // Check if the element receiving focus is outside this component
    // Close when focus leaves the document (relatedTarget is null) or goes outside the component
    if (!event.relatedTarget || !this.element.contains(event.relatedTarget)) {
      this.close()
    }
  }

  closeOnEscape() {
    if (!this.hasDropdownTarget) return

    // Only restore focus if the dropdown was actually open
    const isOpen = !this.dropdownTarget.classList.contains('hidden')
    this.close()
    
    // Restore focus to the toggle button after closing the menu
    if (isOpen && this.hasToggleTarget) {
      this.toggleTarget.focus()
    }
  }
}

Stimulus.register('desktop-nav-link', DesktopNavLinkController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(81)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);